import React from 'react';
import { Checkbox, Col, Empty, Modal, Row, Spin, Typography } from 'antd';
// Types
import { ExtTalentExportColumn } from 'api/graphql-global-types';
import { AdminExtTalentExportOptions_adminExtTalentExportOptions_columns } from 'api/ExtTalent/types/AdminExtTalentExportOptions';
// Styles
import styles from './ExportExternalTalentsModal.module.scss';

const { Text } = Typography;

type ExportExternalTalentsModalProps = {
  exportColumns: AdminExtTalentExportOptions_adminExtTalentExportOptions_columns[];
  isSubmitting: boolean;
  isVisible: boolean;
  loadingOptions: boolean;
  onClose: () => void;
  onColumnsChange: (columns: ExtTalentExportColumn[]) => void;
  onSubmit: () => void;
  selectedColumns: ExtTalentExportColumn[];
};

const ExportExternalTalentsModal = ({
  exportColumns,
  isSubmitting,
  isVisible,
  loadingOptions,
  onClose,
  onColumnsChange,
  onSubmit,
  selectedColumns,
}: ExportExternalTalentsModalProps): JSX.Element => {
  return (
    <Modal
      cancelButtonProps={{ disabled: isSubmitting }}
      closable={!isSubmitting}
      destroyOnClose
      maskClosable={!isSubmitting}
      okButtonProps={{ loading: isSubmitting }}
      okText="Download CSV"
      onCancel={onClose}
      onOk={onSubmit}
      title="Export External Talents"
      visible={isVisible}
      width={720}
    >
      <Text className={styles.description} type="secondary">
        Select columns to include in the export. Leave all columns unselected to
        use the default export columns.
      </Text>

      {loadingOptions ? (
        <Spin />
      ) : exportColumns.length ? (
        <div className={styles.columnsList}>
          <Checkbox.Group
            onChange={(values) =>
              onColumnsChange(values as ExtTalentExportColumn[])
            }
            value={selectedColumns}
          >
            <Row gutter={[16, 8]}>
              {exportColumns.map((column) => (
                <Col className={styles.columnItem} key={column.key} span={12}>
                  <Checkbox value={column.key}>{column.header}</Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </div>
      ) : (
        <Empty
          description="No export columns available"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      )}
    </Modal>
  );
};

export default ExportExternalTalentsModal;
